import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { CapabilityStatusPipe } from 'app/core/pipes/capability-status.pipe';
import { PhoneNumberPipe } from 'app/core/pipes/phone-number.pipe';
import {
  AccountProcessingCapabilities,
  BusinessRepresentative,
  InternalAccount,
  InternalService,
} from '../../../../projects/tilled-api-client/src';

import { CommonModule, TitleCasePipe } from '@angular/common';
import { MatDividerModule } from '@angular/material/divider';
import { ComponentBase } from 'app/core/componentBase';
import { AuthService } from 'app/core/services/auth.service';
import { takeUntil } from 'rxjs';
import { FuseCardComponent } from '../../../@fuse/components/card/card.component';
import { TilledCardRowComponent } from '../tilled-card-row/tilled-card-row.component';
import { TilledHeadingH4Component } from '../tilled-text/tilled-heading/tilled-heading-h4.component';

@Component({
  selector: 'company-profile',
  templateUrl: './company-profile.component.html',
  styleUrls: ['./company-profile.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    FuseCardComponent,
    TilledHeadingH4Component,
    MatDividerModule,
    TilledCardRowComponent,
    PhoneNumberPipe,
    CapabilityStatusPipe,
    CommonModule,
  ],
})
export class CompanyProfileComponent extends ComponentBase implements OnInit {
  @Input() account: InternalAccount;
  public accountType: InternalAccount.TypeEnum;
  public processingCapabilities: AccountProcessingCapabilities;
  public cardCapabilityProviders: string;
  public bankCapabilityProviders: string;
  public cardPresentCapabilityProviders: string;
  public isW9Uploaded: boolean = false;
  public isVoidedCheckOrBLUploaded: boolean = false;
  public isReseller: boolean = false;

  private _titleCase = new TitleCasePipe();

  constructor(
    private _internalService: InternalService,
    private _authService: AuthService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.isReseller = this._authService.isResellerUser();
    this.accountType = this.account?.type;
    if (this.accountType === InternalAccount.TypeEnum.PARTNER) {
      this.getProcessingCapabilities(this.account);
    }
  }

  getRepName(businessRep: BusinessRepresentative): string {
    let nameString = '';
    nameString = businessRep.first_name + ' ';
    if (businessRep.middle_name) {
      nameString += businessRep.middle_name + ' ';
    }
    nameString += businessRep.last_name;

    return nameString;
  }

  getProcessingCapabilities(account: InternalAccount): void {
    this._internalService
      .internalGetAccountProcessingCapabilities({
        tilledAccount: this.account.id,
      })
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((result) => {
        this.processingCapabilities = result;

        const buildProviderDisplay = (type: 'card' | 'debit' | 'card_present') => {
          const regions = ['CA', 'US'];
          const providersMap: Record<string, string[]> = {};

          regions.forEach((region) => {
            const providers = this.processingCapabilities?.capabilities[region]?.[type]?.map((c) => c?.provider) || [];
            providers.forEach((provider) => {
              if (provider) {
                let displayProvider = provider === 'multi_pass' ? 'Multi-pass' : provider;
                displayProvider = this._titleCase.transform(displayProvider);
                if (!providersMap[displayProvider]) {
                  providersMap[displayProvider] = [];
                }
                providersMap[displayProvider].push(region);
              }
            });
          });

          return Object.entries(providersMap)
            .map(([provider, regionList]) => `${provider} (${regionList.join(', ')})`)
            .join(', ');
        };

        this.cardCapabilityProviders = buildProviderDisplay('card');
        this.bankCapabilityProviders = buildProviderDisplay('debit');
        this.cardPresentCapabilityProviders = buildProviderDisplay('card_present');
      });
  }
}
